module.exports = __webpack_public_path__ + "static/media/img-heritage-area6-takashimaTanko.d30c9028.jpg";